<template>
  <vuestic-widget>
    <ul>
      <li>
        <router-link :to="{name: 'topProductos'}">Top Productos Vendidos Por Grupo</router-link>
      </li>
      <li>
        <router-link :to="{name: 'reporteCallCenter'}">Reporte Call Center</router-link>
      </li>
    </ul>
    <router-view />
  </vuestic-widget>

</template>

<script>
    import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    export default {
        name: "reporteMarketing",
      components: {VuesticWidget}
    }
</script>

<style scoped>

</style>
